function useMobileDetect() {
  const token = document.querySelector('meta[name="is-mobile"]')
  const content = token ? token.getAttribute('content') : null;
  const isMobile = Boolean(content === 'true');

  return { isMobile };
}

export default useMobileDetect;
